import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MobileApp from './classes/MobileApp'
import './registerServiceWorker'

window.MobileApp = new MobileApp()

createApp(App)
  .use(store)
  .use(router)
  .mount('#app')
